import { clockConstants } from '../constants/clock.constants';

export function clock(state = {}, action) {
  switch (action.type) {
    case clockConstants.FETCH_REQUEST:
    case clockConstants.REPROCESS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case clockConstants.FETCH_SUCCESS:
      return {
        ...state,
        ...action.clockRegisters,
        loading: false
      };
    case clockConstants.REPROCESS_SUCCESS:
      return {
        ...state,
        clockReprocess: action.clockReprocess,
        loading: false
      };
    case clockConstants.FETCH_FAILURE:
    case clockConstants.REPROCESS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}
